import { combineReducers } from 'redux';
import event from './event';
import sessions from './sessions';
import attendees from './attendees';
import eventChangeManagement from './eventChangeManagement';
import associatedContent from './associatedContent';
import loading from './loading';
import meta from './meta';

export default combineReducers({
  associatedContent,
  event,
  sessions,
  attendees,
  eventChangeManagement,
  meta,
  loading,
});
